import React from 'react';
import { TextLink, Text, Modal, TextList, Button } from 'glic-ui-components'
import ImpContact from './ImpContact';
import { useNavigate } from 'react-router-dom';
const Home = () => {
  let navigate = useNavigate();
  const gotoFindProvider = () => {
    window.open("https://www.guardiananytime.com/fpapp/search",
      "_blank", "width=900, height=600");
  }
  const gotoLink = (evt) => {
    evt.preventDefault();
    window.open(evt.target.id,
      "_blank", "width=900, height=600");
  }
  const NavigateToForm = () => {
    navigate("/GrievanceForm");
  }

  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (e) => { e.preventDefault(); setShow(true); }

  return (

    <><title>Managed dental care home page</title>
      <div>
        <div className="table custom-bg-gray">
          <div className="row">
            <div className='col-8'>
              <div className="table custom-bg-gray">
                <div className="row">
                  <div className="col-12">
                    <Text bodyMd>
                      Welcome to the Managed Dental Care website. Managed Dental Care, a wholly-owned subsidiary of Guardian Life Insurance, has offered quality pre-paid benefits in the state of California since 1997.
                    </Text>
                  </div>
                </div>
                <div className="row">
                  <div className='col-6'>
                    <h2 className="formLabel text-header"
                      color="HudsonNavy" >
                      Find a Dental Provider
                    </h2>
                    <Text bodyMd>
                      You can search for a primary care dentist near you, or check to see if a particular dentist or dental office is in our network. Click Go to get started.
                    </Text>

                    <Button buttonType="submit" decorative onClick={gotoFindProvider}
                      aria-labelledby="findaprovider" role="link"
                    >
                      Find Provider
                    </Button>
                    <span id="findaprovider" class="visually-hidden">  Find Provider opens in new window</span>

                    <br />
                    <br />
                    <Text bodyMd>
                      At Managed Dental Care,we know it's important that our provider directory is accurate.
                      <br /><br />To report any potentially incorrect information in the directory,please contact the Plan's Member Services Department at 1-800-273-3330 or via email at nmc@glic.com
                    </Text>

                  </div>
                  <div className='col-6'>

                    <h2 className="formLabel text-header"
                      color="HudsonNavy" > Grievance Form</h2>
                    <Text bodyMd>
                      If you would like to appeal a referral decision or file a complaint, click GRIEVANCE FORM, which will allow you to describe your situation in detail.
                    </Text>
                    <Button buttonType="submit" decorative onClick={NavigateToForm} aria-labelledby="greivanceform" role="link" >
                      GRIEVANCE FORM
                    </Button>
                    <span id="greivanceform" class="visually-hidden">  Grievance Form </span>
                    <br />
                    <br />
                    <Text bodyMd>
                      Description of MDC's Grievance Process:
                      <br /><br />If you would like to print and file a complaint, Members may select the “Print Grievance Form” link below, fill out the information and mail to the Quality of Care Liaison P.O. Box 25256 Lehigh Valley, PA 18002-5256, fax to 818-596-5853 or email to complaints_grievances@glic.com .
                      {/* <br /><a href="/documents/MDC Grievance Form to Print.pdf" target="_blank" rel="noopener noreferrer">Print Grievance Form</a> */}
                      <br />
                      <TextLink
                          inlineSize="body-md"
                          id="/documents/MDC Grievance Form to Print.pdf"
                          onClick={gotoLink}
                          aria-labelledby="PrintGrievanceForm"
                          style={{ marginTop: '10px', display: 'inline-block' }}>
                          Print Grievance Form
                      </TextLink>
                      <br /><br />Upon receipt of the completed Grievance Form, MDC will acknowledge all written grievances within 5 calendar days and all electronic grievances within 3 calendar days.
                      <br /><br />Members will receive a resolution letter within 30 calendar days from the date MDC receives the complaint.
                      <br /><br />Members have 180 calendar days from the date of an incident to submit a grievance.
                      <br /><br />Please note, in the event you are experiencing a true dental emergency, you may wish to refer to your Certificate of Coverage (“COC”) booklet which includes information regarding the emergency benefits available under your plan.
                    </Text>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-4'>
              <div className='table custom-bg-gray'>
                <div className='row'>
                  <div className='col-12'>
                    <h2 className="formLabel text-header"
                      color="HudsonNavy" >
                      Notice of Change Healthcare Data Security Incident:
                    </h2>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <TextLink
                      inlineSize="body-sm"
                      id="https://www.changehealthcare.com/hipaa-substitute-notice"
                      onClick={gotoLink} aria-labelledby="Hippalink ">
                      https://www.changehealthcare.com/hipaa-substitute-notice
                    </TextLink>
                    <span id="Hippalink" class="visually-hidden">  HIPAA WEBSITE SUBSTITUTE NOTICE opens in new window </span>
                  </div>
                </div>
                <ImpContact></ImpContact>

                <TextLink className="formLabel text-header" inlineSize="body-lg" onClick={handleShow}>
                  Screening Criteria
                </TextLink>

                <div className='row'>
                  <div className='col-12'>
                    <h2 className="formLabel text-header"
                      color="HudsonNavy" >
                      Summary Benefits & Coverage
                    </h2>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <Text bodyMd>
                      You can easily access your Managed Dental Care Summary Benefits and Coverage by clicking here at
                      <TextLink
                        inlineSize="body-sm"
                        id="https://www.guardiananytime.com/"
                        onClick={gotoLink} aria-labelledby="GuardianAnytime">
                        Guardian Anytime
                      </TextLink> and follow these steps:<br />
                      <span id="GuardianAnytime" class="visually-hidden">Guardian Anytime opens in new window </span>
                      <ul>
                        <li>Go to Forms and Material and select Obtain
                          Forms and Materials.</li>
                        <li>Go down to the Benefit Summaries hyperlink.</li>
                        <li>Click the + sign for class and it will display all
                          relevant California Summary of Benefits
                          Comparison Forms for that class</li>
                      </ul>
                    </Text>
                  </div>
                </div>

                <Modal
                  title="SPECIALTY REFERRAL DENIAL GUIDELINES (SCREENING CRITERIA)"
                  show={show}
                  onShow={() => console.log('Show Modal')}
                  submitLabel="Got it"
                  onSubmit={() => setShow(false)}
                  onHide={handleClose}
                  formId="screeningcriteria"
                >
                  <Text color="HudsonNavy">Our denial of the request for specialty referral indicated on the accompanying page was based upon the following guideline(s):</Text>

                  <TextList color="HudsonNavy" type="bulleted">
                    <Text><b>All Referrals</b></Text>
                    <TextList>
                      <TextList.Item>Any procedure that is considered to be within the expected range of a General Dentist's clinical skills.</TextList.Item>
                      <TextList.Item>Any procedure listed as an exclusion, in excess of plan limitations, or as not covered under the plan.</TextList.Item>
                      <TextList.Item>Any procedure that cannot be justified by written or radiographic evidence of pathology.</TextList.Item>
                    </TextList>

                    <Text><b>Endodontics</b></Text>
                    <TextList>
                      <TextList.Item>Root canal treatment which was initiated prior to the member's eligibility to receive benefits under this plan.</TextList.Item>
                      <TextList.Item>Procedures performed to facilitate non-covered services, including but not limited to, root canal therapy to facilitate either hemi section or root amputation.</TextList.Item>
                      <TextList.Item>Endodontic services for a tooth with a hopeless, poor, guarded or questionable endodontic, periodontal or restorative service.</TextList.Item>
                    </TextList>
                    <Text><b>Pediatric Dentistry</b></Text>
                    <TextList>
                      <TextList.Item>Referral to a Pediatric Specialist Dentist after the age limitation determined by the member's Plan.</TextList.Item>
                    </TextList>

                    <Text><b>Oral Surgery</b></Text>
                    <TextList>
                      <TextList.Item>Extractions performed solely to facilitate orthodontic treatment.</TextList.Item>
                      <TextList.Item>Removal of tumors, cysts, neoplasms or foreign bodies that are not tooth related.</TextList.Item>
                      <TextList.Item>Surgical extraction of impacted third molars as listed below:</TextList.Item>
                      <TextList>
                        <TextList.Item>Prophylactic/elective removal of non-pathologic impactions or tooth buds.</TextList.Item>
                        <TextList.Item>Lack of eruptive space.</TextList.Item>
                        <TextList.Item>Non- specific pain.</TextList.Item>
                        <TextList.Item>Pain due to eruption.</TextList.Item>
                        <TextList.Item>Headaches.</TextList.Item>
                        <TextList.Item>Solely for orthodontic reasons. </TextList.Item>
                      </TextList>
                    </TextList>

                    <Text><b>Periodontics</b></Text>
                    <TextList>
                      <TextList.Item>Periodontal scaling and root planning for Case Types I, II and III.</TextList.Item>
                      <TextList.Item>Osseous surgery for teeth with pockets under 5rmn following a re-evaluation performed at least 30 days after scaling and root planning is completed.</TextList.Item>
                      <TextList.Item>Procedures performed to facilitate non-covered services, including, but not limited to, osseous surgery to facilitate either guided tissue regeneration or an osseous graft.</TextList.Item>
                      <TextList.Item>Periodontal services for teeth with hopeless, poor, guarded or questionable endodontic, periodontal or restorative prognosis.</TextList.Item>
                    </TextList>
                  </TextList>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
